import { requestApi } from '../util/network'
// 获取店铺信息
export const getStoreInfo =
    () =>
      requestApi(
        '/Sellersetting/store_info',
        'POST',
        {
        },
        'seller'
      )
export const editStoreInfo =
    (storeQq, storeWw, storePhone, storeMainbusiness, seoKeywords, seoDescription,storeAvatar) =>
      requestApi(
        '/Sellersetting/store_edit',
        'POST',
        {
          'store_qq': storeQq,
          'store_ww': storeWw,
          'store_phone': storePhone,
          'store_mainbusiness': storeMainbusiness,
          'seo_keywords': seoKeywords,
          'seo_description': seoDescription,
          'store_avatar':storeAvatar
        },
        'seller'
      )
export const uploadStoreImage =
    (file) =>
      requestApi(
        '/Sellersetting/store_image_upload',
        'POST',
        file,
        'seller',
        true
      )